module.exports = __webpack_public_path__ + "img/Project_Diagram-Page.23f3700d.svg";